import { Box, Flex } from "@chakra-ui/react";
import TigerLogo from "assets/logos/tiger-cloud-logo.svg?react";
import { Container } from "components/container/Container";
import { signUpComponentStyles } from "./registerComponents";

type AuthFormContainerProps = {
  children: React.ReactNode;
};

export const AuthFormContainer = ({ children }: AuthFormContainerProps) => {
  return (
    <Flex flexDir="column" alignItems="center">
      <Box mb="16" hideFrom="xl" color="fg.default">
        <TigerLogo height={44} />
      </Box>
      <Container {...signUpComponentStyles} data-cy="auth-card">
        {children}
      </Container>
    </Flex>
  );
};
